import React from "react";
import { useTranslation } from "@emisgroup/acp-application-intl";
import "../Style.scss";

export const ScheduleEmptyState: React.FC = () => {
  const { t: translate } = useTranslation();

  return(
    <div className="ebt-schedule-list">
      <h3 className="ebt-schedule-list__empty-state-title">{translate("Scheduling.EmptyStateMessage.Title")}</h3>
      <div className="ebt-schedule-list__empty-state-description">
        <label>{translate("Scheduling.EmptyStateMessage.Description.Line1")}</label>
        <label>{translate("Scheduling.EmptyStateMessage.Description.Line2")}</label>
        <label>{translate("Scheduling.EmptyStateMessage.Description.Line3")}</label>
      </div>
    </div>
  );
};
